import React, { useState } from 'react';
import './FeedbackWidget.css';

const FORMSPREE_URL = 'https://formspree.io/f/xqegrvkk';

// ── Floating feedback tab (Option 4) ─────────────────────
export function FeedbackTab() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState(null);

  const handleSubmit = async () => {
    if (!message.trim()) return;
    setStatus('sending');
    try {
      const res = await fetch(FORMSPREE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message, source: 'floating-tab' }),
      });
      setStatus(res.ok ? 'sent' : 'error');
      if (res.ok) setMessage('');
    } catch {
      setStatus('error');
    }
    if (status !== 'error') setTimeout(() => { setStatus(null); setOpen(false); }, 2500);
  };

  return (
    <>
      <button className="feedback-tab-trigger" onClick={() => setOpen(o => !o)} aria-label="Send feedback">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
        </svg>
        <span>Feedback</span>
      </button>

      {open && (
        <div className="feedback-tab-popover">
          <div className="feedback-tab-header">
            <span className="feedback-tab-title">Share feedback</span>
            <button className="feedback-tab-close" onClick={() => setOpen(false)}>✕</button>
          </div>
          {status === 'sent' ? (
            <p className="feedback-tab-thanks">Thanks for your feedback!</p>
          ) : (
            <>
              <textarea
                className="feedback-tab-textarea"
                placeholder="What could we improve? Any features you'd love to see?"
                value={message}
                onChange={e => setMessage(e.target.value)}
                rows={3}
              />
              <button
                className="feedback-tab-send"
                onClick={handleSubmit}
                disabled={status === 'sending' || !message.trim()}
              >
                {status === 'sending' ? 'Sending…' : status === 'error' ? 'Try again' : 'Send'}
              </button>
            </>
          )}
        </div>
      )}
    </>
  );
}

// ── Post-download feedback modal (Option 2) ──────────────
export function DownloadFeedbackModal({ fileName, onClose }) {
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState(null);

  const handleSubmit = async () => {
    if (!message.trim()) return;
    setStatus('sending');
    try {
      const res = await fetch(FORMSPREE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message, source: 'post-download', fileName }),
      });
      setStatus(res.ok ? 'sent' : 'error');
    } catch {
      setStatus('error');
    }
    if (status !== 'error') setTimeout(onClose, 2000);
  };

  return (
    <div className="dl-feedback-overlay" onClick={onClose}>
      <div className="dl-feedback-modal" onClick={e => e.stopPropagation()}>
        <img src={`${process.env.PUBLIC_URL}/logos/logo.png`} alt="Cedar Resumes" className="dl-feedback-logo" />
        <h2 className="dl-feedback-title">Your PDF is ready!</h2>
        <p className="dl-feedback-sub">{fileName} has been downloaded.</p>

        {status === 'sent' ? (
          <p className="dl-feedback-thanks">Thanks for your feedback!</p>
        ) : (
          <div className="dl-feedback-form">
            <div className="dl-feedback-divider" />
            <p className="dl-feedback-prompt">How was your experience?</p>
            <textarea
              className="dl-feedback-textarea"
              placeholder="What could we improve? Any features you'd love to see?"
              value={message}
              onChange={e => setMessage(e.target.value)}
              rows={3}
            />
            <div className="dl-feedback-actions">
              <button
                className="dl-feedback-send"
                onClick={handleSubmit}
                disabled={status === 'sending' || !message.trim()}
              >
                {status === 'sending' ? 'Sending…' : 'Send feedback'}
              </button>
              <button className="dl-feedback-close" onClick={onClose}>
                Close
              </button>
            </div>
            <p className="dl-feedback-note">Feedback is optional — your PDF is already saved.</p>
          </div>
        )}
      </div>
    </div>
  );
}

// Helper: track download count (for analytics)
export function trackDownload() {
  const count = parseInt(localStorage.getItem('cedar_download_count') || '0', 10) + 1;
  localStorage.setItem('cedar_download_count', String(count));
}
